const getToken = () => {
  return sessionStorage.getItem("token")
    ? JSON.parse(sessionStorage.getItem("token"))
    : null;
};

const setToken = (data) => {
  sessionStorage.setItem("token", JSON.stringify(data));
};

export const ManagerService = {
  getToken,
  setToken,
};
